module.exports = __webpack_public_path__ + "_assets/img/pEasy.25ef2be9.svg";